
const MainHeader = (props: any) => (
    <div className="main-header">
        {props.children}
    </div>
)

export default MainHeader;
